import { createAsyncThunk } from "@reduxjs/toolkit"

import { getTokens } from "src/store/user"
import { loadUserData } from "src/store/auth"

export const loginUser = createAsyncThunk("auth/login", async (data, { dispatch, rejectWithValue }) => {
  try {
    await dispatch(getTokens(data))
    await dispatch(loadUserData())
    return
  } catch (error) {
    return rejectWithValue(error)
  }
})
